import React from 'react';
import TextWithEllipsis from 'src/components/common/TextWithEllipsis';
import { QaError } from '../../../types/QaErrors';
import styles from './ErrorInfo.module.less';

type ErrorInfoProps = {
  errorInfo: QaError;
};

const MAX_ROW_LENGTH = 40;

export const ErrorInfo: React.FC<ErrorInfoProps> = ({ errorInfo }) => {
  return (
    <div className={styles.root}>
      <h2>
        <TextWithEllipsis value={errorInfo.siteCode} maxLength={MAX_ROW_LENGTH} />
      </h2>

      <div className={styles.row}>
        <div className={styles.subRow}>
          <h4 className={styles.boldText}>Application:</h4>
          <p className={styles.text}>{errorInfo.applicationName}</p>
        </div>
        <div className={styles.subRow}>
          <h4 className={styles.boldText}>Script Name:</h4>
          <p className={styles.text}>
            <TextWithEllipsis value={errorInfo.scriptName} maxLength={MAX_ROW_LENGTH} />
          </p>
        </div>
        <div className={styles.subRow}>
          <h4 className={styles.boldText}>Script Health:</h4>
          <p className={styles.text}>{`${errorInfo.scriptHealth}%`}</p>
        </div>
      </div>
    </div>
  );
};
